import { Skeleton } from "@/components/ui/skeleton";

export default function PromotionalSectionSkeleton() {
  return (
    <section className="p-6 my-8 border border-light-grey bg-light rounded-xl w-fit">
      <div className="flex flex-col items-center justify-between gap-6 md:flex-row">
        <div className="flex-1">
          <Skeleton className="h-7 w-64 mb-2" />
          <Skeleton className="h-4 w-80" />
        </div>
        <div className="flex flex-col gap-3 sm:flex-row">
          <Skeleton className="h-10 w-28" />
          <Skeleton className="h-10 w-32" />
        </div>
      </div>
    </section>
  );
}
